/* eslint import/prefer-default-export: "off" */
export const keyCodes = Object.freeze({
  enter: 13,
  escape: 27
})

export const keyboardKeys = Object.freeze({
  esc: 'Esc',
  enter: 'Enter',
  arrowDown: 'ArrowDown',
  arrowUp: 'ArrowUp',
  tab: 'Tab'
})
